module.exports = __webpack_public_path__ + "img/money-bag.be8a0879.png";